import { COLORS } from "@asayinc/component-library";
import { Box } from "@mui/material";
import { IProposal } from "src/store/proxyEvent/types";
import { ProposalWithStats } from "../ProposalWithStats/ProposalWithStats";

const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

interface IProposalSectionProps {
  proposals: IProposal[];
  idx: number;
  isLoading?: boolean;
}

export function ProposalSection({
  proposals,
  idx,
  isLoading,
}: IProposalSectionProps) {
  const multipleProposals = proposals.length > 1;

  if (isLoading) {
    return (
      <Box
        border={`1px solid ${COLORS.P_OUTLINE}`}
        borderRadius={2}
        p={6}
        data-testid={`proposalSection-${idx}-loading`}
      >
        <ProposalWithStats isLoading multi={false} last={false} />
      </Box>
    );
  }

  return (
    <Box
      border={`1px solid ${COLORS.P_OUTLINE}`}
      borderRadius={2}
      p={6}
      data-testid={`proposalSection-${idx}`}
    >
      {proposals.map((proposal, i) => (
        <ProposalWithStats
          key={`${proposal.groupNumber}-${proposal.proposalNumber}`}
          proposal={proposal}
          multi={multipleProposals}
          title={i > 0 ? undefined : `${idx + 1}. ${proposal.title}`}
          details={
            multipleProposals
              ? `${ALPHABET.charAt(i)}. ${proposal.details}`
              : proposal.details
          }
          last={multipleProposals && i === proposals.length - 1}
        />
      ))}
    </Box>
  );
}
